<template>
  <div v-bind:id="'div-option-' + optionId" class="option">
    <div class="esquerda">
      <label :for="'option-' + optionId">
        <input
          v-if="multiple == 0"
          v-bind:id="'option-' + optionId"
          :name="'extra-' + extraId"
          type="radio"
          v-on:click="click(optionId, optionName, price, extraId, multiple)"
        />
        <input
          :extraId="extraId"
          v-if="multiple == 1"
          v-bind:id="'option-' + optionId"
          type="checkbox"
          v-on:click="click(optionId, optionName, price, extraId, multiple)"
          @blur="disableOptions(extraId)"
        />
        <span>{{ optionName }}</span>
      </label>
    </div>
    <div v-bind:class="{ direita: true, 'full-width': true }">
      <div v-if="price > 0" class="preco">
        {{
          price.toLocaleString("pt-br", { style: "currency", currency: "BRL" })
        }}
      </div>
    </div>
  </div>
</template>
<script>
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  props: [
    "optionId",
    "optionName",
    "price",
    "multiple",
    "required",
    "extraId",
    "click",
    "limitQuantity",
    "checkedBoolean",
  ],
  components: {},
})
export default class Option extends Vue {
  mounted() {
    var boolean = false;
    var div = $("#div-option-" + this.$props.optionId);
    var self = this;

    /* Código abaixo para aceitar clique em qualquer parte da div */
    div.click(function () {
      var optionType = self.$props.multiple ? "c" : "r";

      var optionElement = $("#option-" + self.$props.optionId);

      if (optionType == "c") {
        var newVal = !optionElement.prop("checked");
        var inputs = $("input[extraId=" + self.$props.extraId + "]");
        var inputsChecked = $(
          "input[extraId=" + self.$props.extraId + "]:checked"
        );
        setTimeout(function () {
          if (self.$props.limitQuantity != null) {
            if (newVal) {
              if (inputsChecked.length + 1 >= self.$props.limitQuantity) {
                for (var i = 0; i < inputs.length; i++) {
                  if (
                    !$("input[extraId=" + self.$props.extraId + "]")[i].checked
                  )
                    $("input[extraId=" + self.$props.extraId + "]")[
                      i
                    ].setAttribute("disabled", "disabled");
                }
              }
            } else if (self.$props.limitQuantity > inputsChecked.length - 1) {
              for (var i = 0; i < inputs.length; i++) {
                $("input[extraId=" + self.$props.extraId + "]")[
                  i
                ].removeAttribute("disabled");
              }
            }
          }
        }, 200);
      } else {
        var newVal = true;
      }
      if (!optionElement[0].disabled) optionElement.prop("checked", newVal);
      self.$props.click(
        self.$props.optionId,
        self.$props.optionName,
        self.$props.price,
        self.$props.extraId,
        self.$props.multiple
      );
    });
  }

  disableOptions(extraId) {
    let quantityOptions = JSON.parse(sessionStorage.getItem("currentItem"));
    let teste = quantityOptions.extras.map(function (o) {
      return o.extraId == extraId ? o : "";
    });
    // console.log(teste[0].selectedOptions.length);
  }
}
</script>
<style>
.option {
  margin-top: 10px;
  display: flex;
  border-bottom: 1px solid rgba(11, 11, 11, 0.3);
  margin: 5px 10px;
  padding-bottom: 5px;
}
.option .titulo {
  height: 30%;
  font-weight: bold;
  font-size: 1.2rem;
  padding-top: 2px;
}
.option .conteudo {
  height: 40%;
  color: dimgrey;
  overflow: hidden;
  word-wrap: break-word;
}
.option .preco {
  height: 30%;
  color: dimgrey;
  font-size: 1.2rem;
  text-align: right;
}
.option .esquerda {
  width: 90%;
}
</style>
